import axios from "axios";
import {
  getAuthToken,
  getAuthTokenType,
  removeAuthToken,
} from "utils/local-storage";
import { getAPIURL } from "utils/misc";

const apiHelper = async (
  endpoint,
  method,
  data,
  headersData,
  token,
  dispatch
) => {
  const authToken = getAuthToken();
  const tokeType = getAuthTokenType();

  // let url = `${process.env.REACT_APP_API_URL + endpoint}`;
  let url = `${getAPIURL() + endpoint}`;
  let headers = {
    Authorization: `${tokeType} ${authToken}`,
    ...headersData,
    // cookie: `${tokeType}=${authToken}`,
    // withCredentials: true,
  };

  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: data,
      headers: headers,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        if (!endpoint.includes("/activation")) {
          if (
            err.message.includes("401") ||
            err.message.includes("Bad Request")
          ) {
            removeAuthToken();
            document.location.href = "/UI-cn/";
          }
        }

        reject(err);
      });
  });
};

export const getMP3url = async (
  url,
  method,
  data,
  headersData,
  token,
  dispatch
) => {
  const authToken = getAuthToken();
  const tokeType = getAuthTokenType();

  let headers = {
    Authorization: `${tokeType} ${authToken}`,
    ...headersData,
    // cookie: `${tokeType}=${authToken}`,
    // withCredentials: true,
  };

  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: data,
      headers: headers,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const loginApiHelper = async (
  endpoint,
  method,
  data,
  token,
  dispatch
) => {
  let url = `${getAPIURL() + endpoint}`;
  // let url = `${process.env.REACT_APP_API_URL + endpoint}`;
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: data,
      withCredentials: true,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export default apiHelper;

export const apiExternalHelper = async (url, data, method, options = {}) => {
  const config = {
    method: method.toLowerCase(),
    url,
    ...options
  };
  
  if (data) {
    config.data = data;
  }
  
    return axios(config);
};